import { Call, ApiUrl, ParseGeneralResponse } from "./ApiUtils";

const OP = "SLVC";
const opts = { responseDataKeys: { data: "data" } };

function qs(params) {
  const parts = [];
  Object.keys(params).forEach((k) => {
    if (params[k] !== undefined && params[k] !== null && params[k] !== "") parts.push(`${k}=${encodeURIComponent(params[k])}`);
  });
  parts.push(`operation_code=${OP}`);
  return parts.join("&");
}

export function list({ orgId, organizationMoveTypeId, accountId } = {}) {
  const url = ApiUrl(`v2/service_levels?${qs({ org_id: orgId, organization_move_type_id: organizationMoveTypeId, account_id: accountId })}`);
  return Call("get", url, {}, ParseGeneralResponse, opts);
}

export function create(payload) {
  const url = ApiUrl(`v2/service_levels?operation_code=${OP}`);
  return Call("post", url, payload, ParseGeneralResponse, opts);
}

export function update(id, payload) {
  const url = ApiUrl(`v2/service_levels/${id}?operation_code=${OP}`);
  return Call("put", url, payload, ParseGeneralResponse, opts);
}

export function destroy(id) {
  const url = ApiUrl(`v2/service_levels/${id}?operation_code=${OP}`);
  return Call("delete", url, {}, ParseGeneralResponse, opts);
}

export function catalog({ orgId, quotable } = {}) {
  // Phase-4 read API: intentionally omits operation_code so it is not RBAC-gated.
  const parts = [];
  if (orgId !== undefined && orgId !== null && orgId !== "") parts.push(`org_id=${encodeURIComponent(orgId)}`);
  if (quotable) parts.push(`quotable=1`);
  const url = ApiUrl(`v2/service_levels/catalog${parts.length ? `?${parts.join("&")}` : ""}`);
  return Call("get", url, {}, ParseGeneralResponse, opts);
}

export function losOptions(rateSheetId, accountId) {
  // accountId (optional): single-account mode — the backend returns exactly the
  // LOS valid for that account via the canonical dual scope, including
  // account-scoped LOS when the account has no linked rate sheet.
  let url = `v2/service_levels/los_options?rate_sheet_id=${encodeURIComponent(rateSheetId || "")}&operation_code=${OP}`;
  if (accountId) url += `&account_id=${encodeURIComponent(accountId)}`;
  return Call("get", ApiUrl(url), {}, ParseGeneralResponse, opts);
}

export function forAccount(accountId) {
  // Phase-4 read API: auth-only (no operation_code), mirrors catalog(). Returns
  // the same account-applicable + effective-legs shape as accountList() below,
  // minus the SLVC RBAC gate, so Mode A's order-create entry point (which has
  // no SLVC context) can read it.
  const url = ApiUrl(`v2/service_levels/for_account?account_id=${encodeURIComponent(accountId)}`);
  return Call("get", url, {}, ParseGeneralResponse, opts);
}

export function accountList(accountId) {
  const url = ApiUrl(`v2/account_service_levels?account_id=${accountId}&operation_code=${OP}`);
  return Call("get", url, {}, ParseGeneralResponse, opts);
}

// All of one SL's per-account overrides in a single read (edit rehydration).
export function accountOverridesForServiceLevel(serviceLevelId) {
  const url = ApiUrl(`v2/account_service_levels/for_service_level?service_level_id=${serviceLevelId}&operation_code=${OP}`);
  return Call("get", url, {}, ParseGeneralResponse, opts);
}

export function accountUpsert(payload) {
  const url = ApiUrl(`v2/account_service_levels/upsert?operation_code=${OP}`);
  return Call("put", url, payload, ParseGeneralResponse, opts);
}

// All of one SL's per-account override writes + deletes in a single request —
// the org SL drawer's save used to PUT/DELETE once per checked account (1600+
// sequential round-trips on large orgs). Payload:
// { service_level_id, upserts: [{account_id, leg_los}], delete_override_ids }.
export function accountBulkUpsert(payload) {
  const url = ApiUrl(`v2/account_service_levels/bulk_upsert?operation_code=${OP}`);
  return Call("put", url, payload, ParseGeneralResponse, opts);
}

export function accountDestroy(id) {
  const url = ApiUrl(`v2/account_service_levels/${id}?operation_code=${OP}`);
  return Call("delete", url, {}, ParseGeneralResponse, opts);
}
